export const AI_ASSISTANTS_LIST_KEY = 'AI_ASSISTANTS_LIST';
export const AI_ASSISTANTS_ONE_KEY = 'AI_ASSISTANTS_ONE_KEY';

export const AI_ASSISTANTS_GENERATE_START_SEO = 'AI_ASSISTANTS_GENERATE_START_SEO';
